import styles from './ProductAccordion.module.scss'

interface GearInfoElementProps {
  gearInfo: {
    labels: { label: string }[]
    values: string[]
  }
}

export const GearInfoElement = ({ gearInfo }: GearInfoElementProps) => {
  const { labels, values } = gearInfo

  const data = labels.map(({ label }, index) => ({
    label,
    value: values[index],
  }))

  return (
    <div className={styles.dataContainer}>
      {data.map((d) => (
        <div className={styles.dataRow} key={d.label}>
          <div className={styles.dataLabel}>{d.label}</div>
          <div className={styles.dataValue}>{d.value}</div>
        </div>
      ))}
    </div>
  )
}
